export const COOKIES = {
    RH_ACCESS_TOKEN: 'rhaccesstoken',
    RH_DEVICE_TOKEN: 'rhdevicetoken',
    USER: 'user',
};
